import { render, staticRenderFns } from "./packagePromotionService.vue?vue&type=template&id=669db966&scoped=true"
import script from "./packagePromotionService.vue?vue&type=script&lang=js"
export * from "./packagePromotionService.vue?vue&type=script&lang=js"
import style0 from "./packagePromotionService.vue?vue&type=style&index=0&id=669db966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669db966",
  null
  
)

export default component.exports